import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Stack from "react-bootstrap/Stack";
import QRCode from "react-qr-code";

class PlannedTournamentView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      staticData: props.staticData,
      plannedTournament: props.plannedTournament,
      handleCloseRegistration: props.handleCloseRegistration,
      handleOpenRegistration: props.handleOpenRegistration,
      handleUnregister: props.handleUnregister,
      handleStart: props.handleStart,
      handleEdit: props.handleEdit,
      handleMakeEven: props.handleMakeEven,
    };
  }

  render() {
    const {
      staticData,
      plannedTournament: {
        name,
        date,
        startTime,
        endTime,
        eventInfoId,
        scoringFormatId,
        eventVisibilityId,
        courtInfo,
        registrations,
        registrationUrl,
        isRegistrationOpen,
        canStart,
      },
      handleCloseRegistration,
      handleOpenRegistration,
      handleUnregister,
      handleStart,
      handleEdit,
      handleMakeEven,
      handleTierChange,
    } = this.props;

    const tierLabels = staticData.tiers[eventInfoId];

    return (
      <React.Fragment>
        <Container>
          <Row>
            <Col>
              <h1>{name}</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <ButtonGroup>
                <Button variant="warning" size="sm" onClick={handleEdit}>
                  EDIT
                </Button>
                <Button variant="primary" size="sm" disabled={!canStart} onClick={handleStart}>
                  START
                </Button>
                <Button variant="secondary" size="sm" onClick={() => window.location.reload()}>
                  REFRESH
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col className="fw-bold">Registration</Col>
            <Col>
              {isRegistrationOpen && (
                <React.Fragment>
                  Is Open{" "}
                  <ButtonGroup>
                    <Button variant="primary" size="sm" onClick={handleCloseRegistration}>
                      CLOSE
                    </Button>
                    <Button variant="secondary" size="sm" onClick={() => navigator.clipboard.writeText(registrationUrl)}>
                      COPY LINK
                    </Button>
                  </ButtonGroup>
                </React.Fragment>
              )}
              {!isRegistrationOpen && (
                <React.Fragment>
                  Is Closed{" "}
                  <Button variant="primary" size="sm" onClick={handleOpenRegistration}>
                    OPEN
                  </Button>
                </React.Fragment>
              )}
            </Col>
          </Row>
          <Row className="mt-2">
            <Col className="fw-bold">Start</Col>
            <Col>{`${new Date(date).toLocaleDateString()} ${startTime}`}</Col>
          </Row>
          <Row className="mt-2">
            <Col className="fw-bold">End</Col>
            <Col>{`${new Date(date).toLocaleDateString()} ${endTime}`}</Col>
          </Row>
          <Row className="mt-2">
            <Col className="fw-bold">Event Type</Col>
            <Col>{staticData.eventInfos[eventInfoId]}</Col>
          </Row>
          <Row className="mt-2">
            <Col className="fw-bold">Scoring Format</Col>
            <Col>{staticData.scoringFormats[scoringFormatId]}</Col>
          </Row>
          <Row className="mt-2">
            <Col className="fw-bold">Visibility</Col>
            <Col>{staticData.eventVisibilities[eventVisibilityId]}</Col>
          </Row>
          <Row className="mt-2">
            <Col className="fw-bold">Courts</Col>
            <Col>{courtInfo}</Col>
          </Row>
          <Row className="mt-2">
            <Col></Col>
          </Row>
          <Row className="mt-2">
            <Col className="fw-bold">{`Registrations (${registrations.length})`}</Col>
            <Col>
              {" "}
              <Button variant="primary" size="sm" onClick={handleMakeEven}>
                EVEN OUT
              </Button>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <ListGroup>
                {registrations.map((r) => {
                  return (
                    <ListGroup.Item key={r.plannedEventRegistrationId}>
                      <Stack direction="horizontal" gap="2">
                        <ButtonGroup>
                          <Button variant="danger" size="sm" onClick={() => handleUnregister(r.plannedEventRegistrationId)}>
                            DEL
                          </Button>
                          {tierLabels && (
                            <Button
                              variant={r.tierId === "tier1" ? "primary" : "outline-primary"}
                              size="sm"
                              onClick={() => handleTierChange(r.plannedEventRegistrationId, "tier1")}
                            >
                              {tierLabels["tier1"]}
                            </Button>
                          )}
                          {tierLabels && (
                            <Button
                              variant={r.tierId === "tier2" ? "primary" : "outline-primary"}
                              size="sm"
                              onClick={() => handleTierChange(r.plannedEventRegistrationId, "tier2")}
                            >
                              {tierLabels["tier2"]}
                            </Button>
                          )}
                        </ButtonGroup>
                        {r.playerName}
                      </Stack>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </Col>
          </Row>
          <Row className="mt-5 mb-5">
            <Col className="text-center">{isRegistrationOpen && <QRCode level="M" title="Scan to register" value={registrationUrl} />}</Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default PlannedTournamentView;
